export default "__VITE_ASSET__C8Zf5zp4__"